// 计算
const o={
  // 每期利息  一个月及以上 借款金额×年利率/12 | 一个月以下 借款金额×年利率×借款天（7或15）/ 360
  interest(amount,rate,day){
    amount=Number(amount)
    rate=Number(rate)
    day=Number(day)
    let r=0
    if(day<30) r=amount*rate*day/360
    else r=amount*rate/12
    return r
  },
  // 期数  30天为一期，不到30天按一期算
  stag(day){
    day=Number(day)
    return day<=30?1:day/30
  },
  // 每期管理费  借款金额×管理费率
  manageFee(amount,rate){
    amount=Number(amount)
    rate=Number(rate)
    return amount*rate
  },
}
export default o